import React from 'react';
import Select from 'react-select';

class ReplacableSelect extends React.Component {

    constructor (props, context) {
        super(props, context);

        this.options = this.props.options.map((option) => {
            return { value: option.value, label: option.text }
        });

        this.state = {
            value: this.options[0]
        };
    }

    /**
     * On Change handler for react-select
     * 
     * @param {object} value 
     */
    onChange (value) {
        this.setState({ value });
    }

    render () {
        return (
            <div>
                <label dangerouslySetInnerHTML={ {__html: this.props.label} }></label>
                
                <input type="hidden" name={ this.props.name } value={ this.state.value.value } />

                <Select
                    ref={ this.select }
                    id={ this.props.id }
                    classNamePrefix="react-select"
                    options={ this.options }
                    placeholder=""
                    isSearchable={ false }
                    onChange={ this.onChange.bind(this) }
                    value={ this.state.value }
                />
            </div>
        );
    }

}

export default ReplacableSelect;
